import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/HomeView.vue'
import Info from '../views/InfoView.vue'
import { auth } from '../firebase'
import store from '@/store'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      requiresAuth: true
    }

  },
  {
    path: '/info',
    name: 'Info',
    component: Info

  },
  {
    path: '/students',
    name: 'Students',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/StudentsView.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/usermanagement',
    name: 'Users',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/UsermanagementView.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/LoginView.vue')
  },
  {
    path: '/manualsync',
    name: 'Manuele synchronisatie',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ManualSync.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/joboverview',
    name: 'Job overview',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/JobOverview.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/erroroverview',
    name: 'Error overview',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ErrorOverview.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cronjoberroroverview',
    name: 'Cronjob error overview',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/CronjobErrorOverview.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/dubbeleaccounts',
    name: 'Dubbele accounts',
    component: () => import(/* webpackChunkName: "about" */ '../views/DoubleAccounts.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/hoehetwerkt',
    name: 'Hoe de tool werkt',
    component: () => import(/* webpackChunkName: "about" */ '../views/HowItWorks.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/gmailonlyorgs',
    name: 'Gmail-only OU\'s',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/GmailOnlyOrgs.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/workspaceglobals',
    name: 'Workspace situatie',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/WorkspaceGlobals.vue'),
    meta: {
      requiresAuth: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

let userisloggedin = false

// Navigatie-guard ÉÉN keer op module-niveau registreren.
// Voorheen stond dit binnen onAuthStateChanged, waardoor bij elke auth-wijziging
// (login/tokenrefresh/logout) een extra guard werd opgestapeld. De Vue-app wordt
// in main.js pas gemount ná het eerste auth-event, dus userisloggedin is al gezet
// vóór de eerste navigatie — geen race.
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  if (requiresAuth && !userisloggedin) {
    next('/login')
  } else {
    next()
  }
})

auth.onAuthStateChanged(function (user) {
  if (user) {
    userisloggedin = true
    store.dispatch('setLoggedIn', user)
  } else {
    userisloggedin = false
  }
})

/*

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  var userisloggedin = false

   if (requiresAuth && !userisloggedin) {
    next('/login')
  } else {
    next()
  }

}) */

export default router
